import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { ManageCookies } from '../step-landing-page/ManageCookies';
import { getActiveLoading } from '../store/loading-status/selectors';
import { useChatBot } from '../utils/chatbotUtils';
import { BackLink } from '../views-components/BackLink';
import { Wave } from '../wave/Wave';
import { AppMessagingComponent } from './AppMessagingComponent';
import { ContentHolder, FlowStep, FlowStepComponent, ViewComponent } from './AppViewComponent.styles';
export const AppViewComponent = ({
  StepViewComponent
}) => {
  useChatBot();
  const {
    isWideStep,
    waveType
  } = useIsWideStep();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    currentStep
  } = useCurrentStep();
  const activeLoading = useSelector(getActiveLoading);
  const {
    isDesktop
  } = useResponsiveness();
  const showBackLink = isFramedCentredStep && isDesktop;
  return /*#__PURE__*/_jsxs(ViewComponent, {
    isFramedCentredStep: isFramedCentredStep,
    isWideStep: isWideStep,
    children: [/*#__PURE__*/_jsx(FlowStep, {
      children: /*#__PURE__*/_jsx(FlowStepComponent, {
        className: "FlowStepComponent",
        "data-loading": Boolean(activeLoading),
        "data-step": currentStep,
        children: /*#__PURE__*/_jsxs(ContentHolder, {
          isFramedCentredStep: isFramedCentredStep,
          isWideStep: isWideStep,
          children: [showBackLink && /*#__PURE__*/_jsx(BackLink, {}), isFramedCentredStep && /*#__PURE__*/_jsx(AppMessagingComponent, {}), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx(UILoadingSpinner, {
              grow: true,
              size: "extra-small"
            }),
            children: /*#__PURE__*/_jsx(StepViewComponent, {})
          }), waveType && /*#__PURE__*/_jsx(Wave, {
            type: waveType
          })]
        })
      })
    }), !isFramedCentredStep && /*#__PURE__*/_jsx(AppMessagingComponent, {}), !isDesktop && /*#__PURE__*/_jsx(ManageCookies, {})]
  });
};